document.addEventListener('DOMContentLoaded', function() {
  const tabTitles = document.querySelectorAll('[data-tabs-title]');
  const tabContents = document.querySelectorAll('[data-tabs-content]');
  tabTitles.forEach(function(tabTitle, index) {
    tabTitle.addEventListener('click', function() {
      tabTitles.forEach(function(title) {
        title.classList.remove('tabs__header-title-item--active');
      });
      this.classList.add('tabs__header-title-item--active');
      tabContents.forEach(function(content) {
        content.classList.add('hidden');
      });
      tabContents[index].classList.remove('hidden');
    });
  });
});
